import { Button, Icon, useToast } from '@/components/ui';

/**
 * Share a listing: the device's own share sheet where there is one (phones,
 * mostly), otherwise the link goes to the clipboard.
 */
export function ShareButton({ title, text, url = window.location.href }) {
  const toast = useToast();

  async function share() {
    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (error) {
        // Closing the share sheet is a choice, not a failure.
        if (error?.name === 'AbortError') return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copied. Paste it anywhere to share this internship.');
    } catch {
      toast.error('Could not copy the link. Copy it from the address bar instead.');
    }
  }

  return (
    <Button fullWidth variant="secondary" onClick={() => void share()}>
      <Icon name="send" size={16} />
      Share
    </Button>
  );
}
